import React, { useState } from 'react';
import { Pencil, Check, X } from 'lucide-react';

function OpeningPhraseDisplay({ value, onEdit }) {
  return (
    <>
      <button
        onClick={onEdit}
        className="absolute top-2.5 right-2.5 w-7 h-7 rounded-md bg-white hover:bg-[#EEE9FB] flex items-center justify-center text-[#5B4FE8] shadow-sm"
        aria-label="Edit opening phrase"
      >
        <Pencil size={13} />
      </button>
      <pre className="whitespace-pre-wrap font-sans text-[13.5px] text-[#1A1533] leading-relaxed">
        &quot;{value}&quot;
      </pre>
    </>
  );
}

function OpeningPhraseEditor({ draft, setDraft, onSave, onCancel }) {
  return (
    <div>
      <textarea
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        rows={7}
        className="w-full bg-white rounded-lg border border-[#E5DEF9] p-3 text-[13.5px] text-[#1A1533] outline-none focus:ring-2 focus:ring-[#5B4FE8]/30 resize-none"
      />
      <div className="flex justify-end gap-2 mt-2">
        <button
          onClick={onCancel}
          className="px-3 py-1.5 rounded-lg text-[12.5px] text-[#4A4463] hover:bg-white inline-flex items-center gap-1"
        >
          <X size={12} /> Cancel
        </button>
        <button
          onClick={onSave}
          className="px-3 py-1.5 rounded-lg bg-[#5B4FE8] text-white text-[12.5px] font-semibold hover:bg-[#4A3FD9] inline-flex items-center gap-1"
        >
          <Check size={12} /> Save
        </button>
      </div>
    </div>
  );
}

export default function IntroductionPanel({ value, onChange }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);

  const startEdit = () => { setDraft(value); setEditing(true); };
  const save = () => { onChange(draft); setEditing(false); };
  const cancel = () => { setDraft(value); setEditing(false); };

  return (
    <div>
      <h3 className="text-[17px] font-bold text-[#1A1533]">Introduction</h3>
      <p className="text-[13.5px] text-[#4A4463] mt-2 leading-relaxed">
        This is the opening of the interview where Zara introduces herself and asks about the candidate.
      </p>

      <div className="mt-6">
        <label className="text-[13.5px] font-semibold text-[#1A1533]">Opening phrase</label>
        <div className="relative mt-2 rounded-xl bg-[#F1ECFE] border border-[#E5DEF9] p-4">
          {editing ? (
            <OpeningPhraseEditor draft={draft} setDraft={setDraft} onSave={save} onCancel={cancel} />
          ) : (
            <OpeningPhraseDisplay value={value} onEdit={startEdit} />
          )}
        </div>
      </div>
    </div>
  );
}
